import 'animate.css';
import './App.css';
import AppRouter from "./router/AppRouter";
import {isMobile} from 'react-device-detect';
import SystemMessage from "./componetns/SystemMessage/SystemMessage";
import {useEffect, useState} from "react";
import useScreenOrientation from "./hooks/useScreenOrientation";
import {useTypedSelector} from "./hooks/useTypedSelector";
import {useActions} from "./hooks/useActions";
import {config} from "./config";
import {Helmet} from "react-helmet";
import NutakuService from "./services/payments/NutakuService";
import ChangeOrientation from "./pages/orientation/ChangeOrientation";
import StorageHelper from "./services/StorageHelper";
import {IMusic} from "./models/IMusic";
import {canResizeNutakuIframe, resizeNutakuIframe} from "./services/nutaku/NutakuIframeService";

function App() {

    const {isAuth, music} = useTypedSelector(state => state.auth);
    const [currentScreen, setCurrentScreen] = useState(null);
    const [oneSend, setOneSend] = useState(false);
    const {setSystemMessage, setTutorial, setNutakuNickname, setMusic} = useActions();


    const screenOrientation = useScreenOrientation();

    if ((currentScreen !== null && currentScreen !== screenOrientation) && isMobile && !isAuth && !config.isAndroid) {

        if (!oneSend) {
            setOneSend(true);

            let message = {
                type: 'refresh_page',
            };

            window.parent.postMessage(message, '*');
        }
    }
    if (currentScreen === null) {
        // @ts-ignore
        setCurrentScreen(screenOrientation);
    }


    let coreClass = "App";

    if (isMobile) {
        coreClass = 'AppMobile';
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const callback = params.get("patreon_callback");

        if (callback === "1") {
            setSystemMessage({
                isVisible: true,
                type: 'info',
                text: 'Patreon has been successfully connected, please log into the game to receive your bonuses.',
                action: null
            })
        }
    }, []);

    useEffect(() => {

        const musicSetting = StorageHelper.loadMusicSettings();
        const nextMusic: IMusic = {
            ...music,
            ...musicSetting,
        };
        setMusic(nextMusic);

        if (config.isNutaku && config.isAndroid) {

            NutakuService.init()

            return;
        }

        // Працюємо тільки в Nutaku і НЕ Android
        if (!config.isNutaku || config.isAndroid) {
            return;
        }

        let resizeListenerAttached = false;
        let interval: ReturnType<typeof setInterval> | null = null;

        const resize = () => {
            resizeNutakuIframe();
        };

        const runHandshake = async () => {
            const nutaku = (window as any).NutakuGI;
            if (!nutaku?.startHandshake) return;

            try {
                const result = await nutaku.startHandshake();

                if (result.error) {
                    setSystemMessage({
                        isVisible: true,
                        type: 'info',
                        text: 'Nutaku auth error',
                        action: null
                    })
                    return;
                } else if (result.game_rc === 0) {
                    setSystemMessage({
                        isVisible: true,
                        type: 'info',
                        text: 'Nutaku auth error',
                        action: null
                    })
                    return;
                } else {

                    const data = JSON.parse(result.message);

                    localStorage.setItem('jwtToken', data.jwtToken);

                    if (data.tutorial === true) {
                        setTutorial({isActive: true, step: 'Welcome10'});
                    }

                    nutaku.getQuickUserInfo().then(result => {
                        if (!result.error) {

                            setNutakuNickname(result.nickname);

                        } else {
                            console.log('error: ' + result.error);
                        }

                    });
                }

            } catch (e) {
                console.log("Handshake exception:", e);
            }
        };

        const initNutaku = () => {
            if (!canResizeNutakuIframe()) return false;

            // resize одразу
            resize();

            // handshake
            runHandshake();

            // resize listener
            if (!resizeListenerAttached) {
                window.addEventListener("resize", resize);
                resizeListenerAttached = true;
            }

            return true;
        };

        // Чекаємо поки NutakuGI підгрузиться
        interval = setInterval(() => {
            if (initNutaku() && interval) {
                clearInterval(interval);
                interval = null;
            }
        }, 100);

        return () => {
            if (interval) clearInterval(interval);
            if (resizeListenerAttached) {
                window.removeEventListener("resize", resize);
            }
        };
    }, []);

    const [appKey, setAppKey] = useState(0);
    const isLandscape = screenOrientation.includes("landscape");

    useEffect(() => {
        if (isMobile && isLandscape) {
            const t = setTimeout(() => {
                setAppKey(prev => prev + 1);
            }, 100);
            return () => clearTimeout(t);
        }
    }, [isLandscape]);

    useEffect(() => {

        if(!config.isAndroid && !config.isNutaku){
            return;
        }

        const handleNutakuNative = (event: any) => {
            const detail = event?.detail;

            if (detail?.event === 'nutaku-auth-ready') {
                const nickname = detail?.payload?.nickname;

                if (nickname) {
                    setTimeout(() => {
                        setNutakuNickname(nickname);
                    }, 5000);

                }
            }
        };

        window.addEventListener('nutaku-native', handleNutakuNative);

        return () => {
            window.removeEventListener('nutaku-native', handleNutakuNative);
        };
    }, []);


    return (
        <>
            {!(config.isNutaku) && (
                <Helmet>
                    <meta name="description" content="Depraved World game, adult, sex, porn, hot. Play now!"/>
                    {config.env === 'dev' && <meta name="robots" content="noindex"/>}
                </Helmet>
            )}
            <div className={coreClass}>
                {(isMobile && !isLandscape && !config.isAndroid) ?
                    <ChangeOrientation/>
                    :<AppRouter key={appKey} />
                }
                <SystemMessage/>
            </div>
        </>
    );
}

export default App;
